import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { AddPostLikePayload } from '@web/newsfeed/types/apiTypes';
import { useNewsfeedBridge } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';

type OnRemoveLikeMutate = (articleId: ID) => void;

export const useRemoveArticleLike = (onRemoveLikeMutate: OnRemoveLikeMutate) => {
  const { newsfeed } = useSlingApi();
  const newsfeedBridge = useNewsfeedBridge();

  const mutation = useMutation({
    mutationFn: async ({ pageId, articleId }: AddPostLikePayload) => {
      const result = await newsfeed.removeLike(pageId, articleId);
      return result.data;
    },
    onMutate: (payload) => {
      onRemoveLikeMutate(payload.articleId);
    },
    onSuccess: (payload) => {
      newsfeedBridge.onRemoveArticleLike(payload);
    },
  });

  return mutation;
};
